import { Box } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'
import { useNavigate } from 'react-router-dom'
import CommentCountIcon from 'components/ui/comment-count-icon'

interface CommentCellProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  densityStyles: DensityStyleTypes
  route?: string
}

const AccountingCommentCell: FC<CommentCellProps> = ({ params, densityStyles, route: _route }) => {
  const { PK, SK, isParent: _isParent, count } = params?.row ?? {}
  const commentRoute = `/accounting/${PK}/${SK}/comments`
  const navigate = useNavigate()
  const handleNavigate = () => {
    navigate(commentRoute)
  }
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      key={params?.row?.id}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'left',
        width: '100%',
        height: '100%',
        cursor: 'pointer',
      }}
      onClick={handleNavigate}
    >
      <CommentCountIcon commentCount={count ?? 0} boardTheme={'icon.accounting'} densityStyles={densityStyles} />
    </Box>
  )
}
export default AccountingCommentCell
